import { RouteComponentProps } from '@reach/router'
import React from 'react'

import AppointmentView from '@cinch/oxd-pages/wbac/src/components/appointment-view/appointment-view.component'
import { BookResponse, PersonalInformationResponse, Pages } from '@cinch/oxd-pages/wbac/src/types'
import SEO from '../../../../../apps/www/src/components/seo'

const AppointmentBookedComponent: React.FC<RouteComponentProps & { path: Pages } & any> = ({ location, navigate }) => {
  if (!location.state || !location.state.appointment) {
    setTimeout(() => navigate('/sell'))

    return null
  }

  const { appointment, personalInformation } = location.state as {
    appointment: BookResponse
    personalInformation: PersonalInformationResponse
  }

  return (
    <>
      <SEO noIndex={true} />
      {appointment && <AppointmentView appointment={appointment} personalInformation={personalInformation} />}
    </>
  )
}

export default AppointmentBookedComponent
